import dayjs from "dayjs";

const useStartDates = () => {
  const getStartDateMonths = (
    dates: Array<{ start_date: number; end_date: number }>
  ) => {
    const months = dates.map((eachDate) => {
      // if (eachDate.end_date) {
      //   let startDate = dayjs(eachDate.start_date * 1000).set("date", 1);
      //   const endDate = dayjs(eachDate.end_date * 1000).set("date", 2);
      //   let months = "";
      //   while (startDate.isBefore(endDate)) {
      //     months += `${startDate.format("MMM")}/`;
      //     startDate = startDate.add(1, "month");
      //   }
      //   return months.substring(0, months.length - 1);
      // } else {
      return dayjs(eachDate.start_date * 1000).format("MMM");
      // }
    });
    const parts = months.flatMap((item) => item.split("/"));
    // @ts-ignore
    const uniqueParts = [...new Set(parts)];
    const uniqMonths = uniqueParts.join("/");
    return uniqMonths;
  };

  return getStartDateMonths;
};

export default useStartDates;
